import { WarrantyRegistrationSchema } from "@redotech/redo-model/warranty-registration";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const updateWarrantyRegistrationCustomItem = {
  name: "updateWarrantyRegistrationCustomItem" as const,
  input: z.object({
    registrationId: zExt.objectId(),
    name: z.string(),
    sku: z.string().optional(),
    price: z.string(),
  }),
  output: WarrantyRegistrationSchema,
};
